<template>
  <div class="foot">
     <div class="wrap">
      <div class="foot-box">
        <div class="left">
          <img class="fooot-logo" src="@/assets/images/footLogo.png">
          <p>全网价值营销服务商</p>
        </div>
        <div class="right">
          <div class="link-item">
            <h3>友情链接</h3>
            <a>香港创新科技局</a>
            <a>创新科技及工业局</a>
            <a>香港科技大学</a>
            <a>香港科技园</a>
            <a>香港数码港</a>
          </div>
          <div class="link-item">
            <h3>服务城市</h3>
            <p>香港</p>
            <p>深圳</p>
            <p>珠海</p>
            <p>佛山</p>
          </div>
          <div class="link-item">
            <h3>更多</h3>
            <a><router-link to="/Solution" >解决方案</router-link></a>
            <a><router-link to="/Case" >客户案例</router-link></a>
            <a><router-link to="/AboutUs" >关于我们</router-link></a>
            <a><router-link to="/ContactUs" >联系我们</router-link></a>
          </div>
        </div>
      </div>
     </div>
     <p>&copy; 2026 ZhongShan YunYang Information Technology Co., Ltd. All Rights Reserved.</p>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style scoped>
  .foot{
    width: 100%;
    position: relative;
  }
  .foot p{
    font-size: 14px;
  }
  .foot>p{
    text-align: center;
    padding: 25px 0;
    border-top: 1px solid #393939;
  }
  .foot h3{
    font-size: 18px;
  }
  .foot-box{
    display: flex;
    justify-content: space-between;
    padding: 60px 0;
  }
  .fooot-logo{
    width: 160px;
    display: block;
  }
  .foot-box .left{
    width: 500px;
  }
  .foot-box .left p{
    margin: 15px 0;
  }
  .foot-box .right{
    display: flex;
    flex: 1;
    justify-content: space-between;
    position: relative;
  }
  .foot-box .right::after{
    content: '';
    width: 100%;
    height: 1px;
    background: #393939;
    display: block;
    margin: 15px 0;
    position: absolute;
    top: 30px;
  }
  .foot-box .right .link-item a{
    display: block;
    line-height: 32px;
    font-size: 14px;
  }
  .foot-box .right .link-item h3{
    line-height: 32px;
    margin-bottom: 30px;
  }
  .foot-box .right .link-item p{
    line-height: 38px;
  }
  .foot-box .right .link-item a{
   color: #888888;
  }
  
 
  </style>
  